export default  {
    controller: 'reportListController',
    template: require('../views/reports.list.html')
  };
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/reports/components/reports.list.component.js